import { LegalLayout } from "@/layouts/LegalLayout.tsx";

export function ImprintPage() {
    return <LegalLayout url="/imprint.html" />;
}
